// sections/SmartMatchingSection.tsx
import React from "react";
import { Container, Row, Col } from "reactstrap";
import { BarChart, Star, Clock } from "lucide-react";

// Import image
import contractorMeeting from "./images/contractor-matching.jpg";

const SmartMatchingSection: React.FC = () => {
  const features = [
    {
      icon: BarChart,
      title: "AI-Powered Matching",
      description: "Our algorithm matches you with the perfect contractors based on project requirements, location, and expertise.",
    },
    {
      icon: Star,
      title: "Quality Scoring",
      description: "Contractors are rated based on work quality, reliability, and customer satisfaction.",
    },
    {
      icon: Clock,
      title: "Response Time Guarantee",
      description: "Get matched with available contractors within 24 hours.",
    },
  ];

  return (
    <section className="py-5 bg-white">
      <Container>
        <Row className="align-items-center">
          <Col md="6" className="mb-4 mb-md-0">
            <h2 className="fs-1 fw-bold mb-4">Smart Contractor Matching</h2>
            <div className="mb-4">
              {features.map((feature, index) => (
                <div className="d-flex mb-3" key={index}>
                  <feature.icon className="feature-icon-sm text-primary me-3 flex-shrink-0" />
                  <div>
                    <h3 className="fw-semibold mb-2">{feature.title}</h3>
                    <p className="text-muted">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
          <Col md="6">
            <img
              src={contractorMeeting}
              alt="Contractor meeting"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SmartMatchingSection;